import script from "./ToastMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastMessage.vue?vue&type=script&setup=true&lang=js"

import "./ToastMessage.vue?vue&type=style&index=0&id=fd65c950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd65c950"]])

export default __exports__